export const CHANGE_LOCALE = 'language/CHANGE_LOCALE'
export const DEFAULT_LOCALE = 'en'
